import React, { Component } from 'react'

export class Service extends Component {
    render() {
        return (
            <div>
                <div className="section is-hero has-gradient position-relative overflow-hidden is-subpage">
    <div className="container position-relative">
      <div className="col block-centered text-align-center lg-7 md-12">
        <h1>Services</h1>
        <div className="padding-left padding-right margin-bottom is-heading-color">Innovation and simplicity makes us happy: our goal is to remove any technical or financial barriers that can prevent business owners from making a website.</div>
      </div>
    </div><img src="images/header2.svg" alt="" className="header-image style2" /></div>
  <div className="section no-padding-bottom">
    <div className="container">
      <div className="col block-centered text-align-center lg-6 md-12">
        <h2>Our full suite of services</h2>
        <div className="padding-left padding-right margin-bottom text-medium low-text-contrast">Lorem ipsum dolor sit amet, consectetur adipiscing elit conestuer bolorian elitarian</div>
      </div>
    </div>
    <div className="container flex-horizontal is-wrapping">
      <div className="col lg-4 md-12">
        <div className="flexh-align-center">
          <div className="c-iconbox1__icon"><img src="images/icon15.svg" width="75" alt="" /></div>
          <div>
            <h4>Organizational Development</h4>
            <div className="margin-bottom-small">Aenean lacinia bibendum nulla sed consectetur enean lacinia bibendum nulla sed </div><a href="#" className="cta-link"><span className="margin-right">Learn more</span> <span className="fa c-cta1_arrow-hovered"></span> <span className="fa c-cta1__arrow-normal"></span></a></div>
        </div>
      </div>
      <div className="col lg-4 md-12">
        <div className="flexh-align-center margin-bottom">
          <div className="c-iconbox1__icon"><img src="images/icon13.svg" width="75" alt="" /></div>
          <div>
            <h4>Consulting Services</h4>
            <div className="margin-bottom-small">posuere consectetur est at lobortis.t non commodo luctus, nisi erat </div><a href="#" className="cta-link"><span className="margin-right">Learn more</span> <span className="fa c-cta1_arrow-hovered"></span> <span className="fa c-cta1__arrow-normal"></span></a></div>
        </div>
      </div>
      <div className="col lg-4 md-12">
        <div className="flexh-align-center margin-bottom">
          <div className="c-iconbox1__icon"><img src="images/icon12.svg" width="75" alt="" /></div>
          <div>
            <h4>Sales and Implementation</h4>
            <div className="margin-bottom-small">Duis mollis, est non commodo luctus, nisi erat porttitor ligula, eget lacinia </div><a href="#" className="cta-link"><span className="margin-right">Learn more</span> <span className="fa c-cta1_arrow-hovered"></span> <span className="fa c-cta1__arrow-normal"></span></a></div>
        </div>
      </div>
      <div className="col lg-4 md-12">
        <div className="flexh-align-center margin-bottom">
          <div className="c-iconbox1__icon"><img src="images/icon5_1.svg" width="75" alt=""/></div>
          <div>
            <h4>Performance Improvement</h4>
            <div className="margin-bottom-small">Duis mollis, est non commodo luctus, nisi erat porttitor ligula, eget lacinia </div><a href="#" className="cta-link"><span className="margin-right">Learn more</span> <span className="fa c-cta1_arrow-hovered"></span> <span className="fa c-cta1__arrow-normal"></span></a></div>
        </div>
      </div>
      <div className="col lg-4 md-12">
        <div className="flexh-align-center margin-bottom">
          <div className="c-iconbox1__icon"><img src="images/people.svg" width="75" alt=""/></div>
          <div>
            <h4>Staffing Support</h4>
            <div className="margin-bottom-small">Duis mollis, est non commodo luctus, nisi erat porttitor nec elit. </div><a href="#" className="cta-link"><span className="margin-right">Learn more</span> <span className="fa c-cta1_arrow-hovered"></span> <span className="fa c-cta1__arrow-normal"></span></a></div>
        </div>
      </div>
      <div className="col lg-4 md-12">
        <div className="flexh-align-center margin-bottom">
          <div className="c-iconbox1__icon"><img src="images/icon11_1.svg" width="75" alt=""/></div>
          <div>
            <h4>Vendor Management</h4>
            <div className="margin-bottom-small">Duis mollis, est non commodo luctus, nisi erat porttitor ligula, eget lacinia </div><a href="#" className="cta-link"><span className="margin-right">Learn more</span> <span className="fa c-cta1_arrow-hovered"></span> <span className="fa c-cta1__arrow-normal"></span></a></div>
        </div>
      </div>
    </div>
  </div>
  <div className="container">
    <div className="col lg-12 no-margin-bottom">
      <div className="hr"></div>
    </div>
  </div>
  <div className="section">
    <div className="container">
      <div className="col lg-12">
        <div className="w-layout-grid c-grid8x1">
          <div className="fa-brand _70px"></div>
          <div className="fa-brand _70px"></div>
          <div className="fa-brand _70px"></div>
          <div className="fa-brand _70px"></div>
          <div className="fa-brand _70px"></div>
          <div className="fa-brand _70px"></div>
          <div className="fa-brand _70px"></div>
          <div className="fa-brand _70px"></div>
        </div>
      </div>
    </div>
  </div>
  <div className="container">
    <div className="col lg-12 no-margin-bottom">
      <div className="hr"></div>
    </div>
  </div>
  <div className="section">
    <div className="container">
      <div className="col block-centered text-align-center lg-8 md-12">
        <h2>Our approachment</h2>
        <div className="padding-left padding-right margin-bottom low-text-contrast text-medium">We work with our financial services clients as partners. Together we develop clear, practical action plans, and support or run the implementation of those plans to ensure real and sustainable performance improvement.</div>
      </div>
    </div>
    <div className="container is-wide">
      <div className="col lg-3 md-4 sm-12">
        <div className="flexh-space-between">
          <div className="text-xlarge low-text-contrast margin-right-small">01. </div>
          <div>
            <div className="size-h4 margin-bottom-small">Customer orientation to drive organic growth</div>
            <div className="margin-bottom text-small">Vestibulum id ligula porta felis euismod semper bvivamus sagittis lacus vel augue laoreet </div><a href="#" className="text-small">Read more</a></div>
        </div>
      </div>
      <div className="col lg-3 md-4 sm-12">
        <div className="flexh-space-between">
          <div className="text-xlarge low-text-contrast margin-right-small">02. </div>
          <div>
            <div className="size-h4 margin-bottom-small">Reducing costs and complexity to improve performance</div>
            <div className="margin-bottom text-small">Vivamus sagittis lacus vel augue laoreet rutrum faucibus dolor auctor</div><a href="#" className="text-small">Read more</a></div>
        </div>
      </div>
      <div className="col lg-3 md-4 sm-12">
        <div className="flexh-space-between">
          <div className="text-xlarge low-text-contrast margin-right-small">03. </div>
          <div>
            <div className="size-h4 margin-bottom-small">Harnessing and sourcing information technology that is aligned with strategy</div>
            <div className="margin-bottom text-small">Vivamus sagittis lacus vel augue laoreet rutrum </div><a href="#" className="text-small">Read more</a></div>
        </div>
      </div>
      <div className="col lg-3 md-4 sm-12">
        <div className="flexh-space-between">
          <div className="text-xlarge low-text-contrast margin-right-small">04. </div>
          <div>
            <div className="size-h4 margin-bottom-small">Integrating acquired companies to realize the most value</div>
            <div className="margin-bottom text-small">Vivamus sagittis lacus vel augue laoreet rutrum faucibus dolor auctor</div><a href="#" className="text-small">Read more</a></div>
        </div>
      </div>
      <div className="col lg-3 md-4 sm-12">
        <div className="flexh-space-between">
          <div className="text-xlarge low-text-contrast margin-right-small">05. </div>
          <div>
            <div className="size-h4 margin-bottom-small">Customer orientation to drive organic growth</div>
            <div className="margin-bottom text-small">Vivamus sagittis lacus vel augue laoreet rutrum faucibus dolor auctor</div><a href="#" className="text-small">Read more</a></div>
        </div>
      </div>
    </div>
  </div>
  <div className="section no-padding-top xs-no-padding-bottom">
    <div className="container is-wide">
      <div className="col lg-12 position-relative xs-no-margin-bottom"><img src="images/2126.jpg" sizes="(max-width: 479px) 90vw, (max-width: 767px) 94vw, (max-width: 991px) 95vw, 97vw" alt=""/>
        <div className="c-quotebox has-shadow">
          <div className="quotemark2">“</div>
          <div className="text-medium margin-bottom-double">Financia solved my problem with ease. Great customer service highly recommend. On tomorrow of the quality in clothing too!</div>
          <div className="text-small is-bold">Noah John</div>
          <div className="text-small">Architect at Surabaya jatim</div>
        </div>
      </div>
    </div>
  </div>
  <div className="section has-bg-image2 position-relative overflow-hidden">
    <div className="container position-relative">
      <div className="col lg-7 md-12 block-centered">
        <div className="text-align-center on-dark">
          <div className="margin-bottom-double">
            <div className="size-h2 on-dark margin-bottom">Unlock the digital world and begin your organization’s transformation</div>
            <div>Get in touch with a sales professional.</div>
          </div>
          <div>
            <a href="#" className="button-primary is-white w-inline-block">
              <div className="button-primary-text">Let&#x27;s talk</div>
            </a>
          </div>
        </div>
      </div>
    </div><img src="images/header2.svg" alt="" className="header-image position2"/></div>
            </div>
        )
    }
}

export default Service